<template>
  <v-container class="box-container ma-0 pa-0">
    <v-col cols="12" justify="center" class="row-content ma-0 px-4 pa-0" v-if="user">
      <v-switch hide-details dense class="mа-0 pa-0 pb-2" inset v-model="darkMode" :color="Colors.IconColor" :label="TR.DarkMode"></v-switch>
      <v-switch hide-details dense class="mа-0 pa-0 pb-2" inset v-model="denseGrid" :color="Colors.IconColor">
        <template v-slot:label>
          <span>{{ TR.DenseMode }}</span>
          <v-menu open-on-hover bottom offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-on="on" v-bind="attrs" icon small color="info">
                <v-icon small>mdi-information</v-icon>
              </v-btn>
            </template>
            <v-card flat>
              <v-simple-table :dense="userSettings.denseGrid">
                <thead>
                  <tr>
                    <th>{{ TR.Title + " 1" }}</th>
                    <th>{{ TR.Title + " 2" }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>{{ TR.Column + " 1" }}</td>
                    <td>{{ TR.Column + " 2" }}</td>
                  </tr>
                </tbody>
              </v-simple-table>
            </v-card>
          </v-menu>
        </template>
      </v-switch>
      <!-- <v-switch hide-details dense class="mа-0 mx-3 pa-0" inset v-model="userSettings.showFlyingHelp" :color="Colors.IconColor">
        <template v-slot:label>
          <span>Показвай помощен прозорец</span>
        </template>
      </v-switch> -->
      <v-switch hide-details dense class="mа-0 pa-0 pb-2" inset v-model="userSettings.showTimeOnDatePicker" :color="Colors.IconColor" :label="TR.ShowClockWithDates"></v-switch>
      <v-switch hide-details dense class="mа-0 pa-0 pb-2" inset v-model="userSettings.showTooltips" :color="Colors.IconColor">
        <template v-slot:label>
          <v-tooltip :disabled="hideTooltips" right style="z-index: 10">
            <template v-slot:activator="{ on }">
              <span v-on="on">{{ TR.ShowTooltips }}</span>
            </template>
            <span>{{ TR.ExampleTooltip }}</span>
          </v-tooltip>
        </template>
      </v-switch>
      <v-switch v-if="TR.Locale == Translation.bg.Locale" hide-details dense class="mа-0 pa-0 pb-2" inset v-model="hideOldModels" :color="Colors.IconColor" :label="TR.DontShowOldModels"></v-switch>
      <v-select :label="TR.StartPage + ':'" clearable clear-icon="mdi-close" class="ma-0 pa-0 pt-6" :items="routes" v-model="startPage" item-value="path" item-text="name" dense></v-select>
      <template v-if="TR.Locale == Translation.bg.Locale">
        <v-text-field :label="TR.ContactPhone + ':'" class="ma-0 pa-0 pt-4" clearable clear-icon="mdi-close" v-model="user.phoneNumber" dense></v-text-field>
        <v-text-field :label="TR.NotificationEmail + ': '" :rules="[...global_rules.email]" class="ma-0 pa-0 pt-4" clearable clear-icon="mdi-close" v-model="user.emailDeviceAction" dense></v-text-field>
      </template>
      <template v-else>
        <v-text-field :label="TR.Email + ': '" :rules="[...global_rules.email]" class="ma-0 pa-0 pt-4" clearable clear-icon="mdi-close" v-model="user.email" dense></v-text-field>
        <v-text-field :label="TR.NotificationEmail + ': '" :rules="[...global_rules.email]" class="ma-0 pa-0 pt-4" clearable clear-icon="mdi-close" v-model="user.emailDevieAction" dense></v-text-field>
      </template>
      <v-row class="mа-2 pa-3 py-5">
        <t-button :btnDisabled="isSaveDisabled" class="mа-0 pa-0" :btnIcon="'mdi-checkbox-marked-circle-outline'" :btnText="TR.Save" @click.native="saveUserSettings()" />
      </v-row>
    </v-col>
    <v-col class="row-header" cols="12">
      <v-card-text class="mа-0 pa-0">{{ "Tremol Assistant " + TR.Version + ": " + getAppVer() }}</v-card-text>
    </v-col>
  </v-container>
</template>

<script>
import DataManager, { ErrorMessage } from "../../js/DataManager";
import { version } from "../../../package.json";
import { TR } from "../../main";
import Translation from "../../js/Translation";
export default {
  components: {},
  data() {
    return {
      isSaveDisabled: false,
      user: null,
      TR: TR,
      Translation: Translation,
    };
  },
  methods: {
    setTitleAndData(meta, error) {
      if (error.ErrorCode == ErrorMessage.ERROR_CODE_OK) {
        this.user = DataManager.getData(DataManager.DataType.user);
      }
    },
    getAppVer() {
      return version;
    },
    saveUserSettings() {
      // if (!this.$refs || !this.$refs.refRegistrationForm || !this.$refs.refRegistrationForm.validate()) {
      //   return;
      // }
      if (this.user.emailDeviceAction && !this.isValidEmail(this.user.emailDeviceAction)) {
        this.dialogLoader.showError(TR.InvalidEmail);
        return;
      }
      if (this.user.emailDevieAction && !this.isValidEmail(this.user.emailDevieAction)) {
        this.dialogLoader.showError(TR.InvalidEmail);
        return;
      }
      if (this.user.phoneNumber) {
        this.user.phoneNumber = this.user.phoneNumber.replaceAll(" ", "");
        if (this.user.phoneNumber.indexOf("0") == 0) {
          this.user.phoneNumber = this.user.phoneNumber.replace("0", "+359");
        }
        if (this.user.phoneNumber.length != 13) {
          this.dialogLoader.showError(TR.InvalidPhone);
          return;
        }
      }
      this.isSaveDisabled = true;
      DataManager.data[DataManager.DataType.user.id].settings1.interface = this.userSettings;
      var globalEmail = null;
      var globalNotifEmail = null;
      if (TR.Locale != Translation.bg.Locale) {
        globalEmail = DataManager.data[DataManager.DataType.user.id].email;
        globalNotifEmail = DataManager.data[DataManager.DataType.user.id].emailDevieAction;
      }
      DataManager.updateUserSettings(DataManager.data[DataManager.DataType.user.id].settings1, null, null, globalEmail, globalNotifEmail, (error) => {
        if (error.ErrorCode == ErrorMessage.ERROR_CODE_OK) {
          if (TR.Locale == Translation.bg.Locale) {
            DataManager.changeUserContactInfo(this.user.emailDeviceAction, (err2) => {
              if (err2.ErrorCode == ErrorMessage.ERROR_CODE_OK) {
                this.dialogLoader.showInfo(TR.SaveSuccessful);
              } else {
                this.dialogLoader.showError(err2.Message);
              }
              setTimeout(() => {
                this.isSaveDisabled = false;
              }, 3000);
            });
          } else {
            this.dialogLoader.showInfo(TR.SaveSuccessful);
            setTimeout(() => {
              this.isSaveDisabled = false;
            }, 3000);
          }
        } else {
          this.dialogLoader.showError(error.Message);
          setTimeout(() => {
            this.isSaveDisabled = false;
          }, 3000);
        }
      });
    },
  },
  computed: {
    routes() {
      return this.$router.options.routes
        .filter((f) => f.name == "MainContent")[0]
        .children.filter((r) => r.meta && DataManager.userHasAccess(r.meta.for_user) && !DataManager.userHasAccess(r.meta.not_for_user) && r.path.startsWith("/" + TR.Locale + "/"))
        .map((r) => ({
          name: r.meta.group == r.title ? r.title : r.meta.group + " ↪ " + r.title,
          path: r.path,
        }));
    },
    startPage: {
      get() {
        return this.routes.find((r) => r.path == this.userSettings.startPage);
      },
      set(newValue) {
        setTimeout(() => {
          this.userSettings.startPage = newValue;
        }, 50);
      },
    },
    hideOldModels: {
      get() {
        return this.userSettings.hideOldModels;
      },
      set(newValue) {
        setTimeout(() => {
          this.userSettings.hideOldModels = newValue;
        }, 50);
      },
    },
    darkMode: {
      get() {
        return this.userSettings.darkMode;
      },
      set(newValue) {
        setTimeout(() => {
          this.userSettings.darkMode = newValue;
          this.$vuetify.theme.dark = newValue;
        }, 50);
      },
    },
    denseGrid: {
      get() {
        return this.userSettings.denseGrid;
      },
      set(newValue) {
        setTimeout(() => {
          this.userSettings.denseGrid = newValue;
        }, 50);
      },
    },
  },
};
</script>

<style lang="css" scoped>
div.my-tabs [role="tab"] {
  justify-content: flex-start;
}
</style>